'use client';

import { useDialogContext } from '@/contexts/DialogContext';
import { PathEnum } from '@/i18n/locale-config';
import { Link } from '@/i18n/navigation';
import useCartStore, { Ticket as TicketType } from '@/store/cartStore';
import { cn } from '@/utils/tailwind-merge';
import { useLocale, useTranslations } from 'next-intl';
import CartDialog from '../blocks/CartDialog';
import Image from '../Image';
import Button from './Button';

const Ticket = ({ ticket }: { ticket: TicketType }) => {
    const t = useTranslations();
    const locale = useLocale() as 'en' | 'fr';
    const { name, description, price, ...rest } = ticket;
    const { enqueueDialog } = useDialogContext();
    const { addItem } = useCartStore();
    // TODO: FIX
    // const isAddToCartDisabled = ticket.is_active === false;
    const isAddToCartDisabled = true;

    const openCartDialog = () => enqueueDialog(<CartDialog initialStep={2} />);

    const isSingleUse =
        rest.usage_limits.single_use &&
        rest.usage_limits.online === 1 &&
        rest.usage_limits.in_cinema === 1;
    const isUnavailable = rest.purchase_location === 'BOX_OFFICE';

    const handleClick = () => {
        addItem({ ticket, quantity: 1 });
        openCartDialog();
    };

    return (
        <div className="flex flex-col gap-7 border border-white/50 p-5 justify-between">
            <div className="flex flex-col justify-start gap-2">
                <p className="text-3xl sm:text-5xl uppercase">{name[locale]}</p>
                <p className="font-helvetica-neue text-sm sm:text-xl text-gray-200 font-light">
                    {description[locale]}
                </p>
            </div>
            <div className="flex flex-col md:flex-row gap-5 justify-between md:items-center">
                <p className="text-primary text-5xl">$ {price}</p>
                {/* Button Here */}
                {!isUnavailable ? (
                    <>
                        {isSingleUse ? (
                            <Link
                                href={PathEnum.Films}
                                className="w-full max-w-96 py-3 px-5 md:px-20 bg-primary uppercase font-trade-gothic text-2xl text-center text-black text-nowrap h-14 "
                            >
                                <span className="w-56 mx-auto block text-center">
                                    {t('Common.viewFilms')}
                                </span>
                            </Link>
                        ) : (
                            <Button
                                className={cn(
                                    'flex items-center w-full max-w-96 border-primary border border-solid py-2 px-5 md:px-20 h-14',
                                    isAddToCartDisabled ? 'bg-disabled border-disabled' : '',
                                )}
                                onClick={handleClick}
                                variant="secondary"
                                title={
                                    !isAddToCartDisabled
                                        ? t('Cart.addToBasket')
                                        : t('Cart.notAvailable')
                                }
                                textClasses="font-trade-gothic font-normal text-2xl leading-none"
                                disabled={isAddToCartDisabled}
                            >
                                {!isAddToCartDisabled ? (
                                    <Image
                                        className="ml-4"
                                        src="/img/icons/basket-black.svg"
                                        alt="Basket Icon"
                                        width={36}
                                        height={36}
                                    />
                                ) : (
                                    <span className="w-0 h-9"></span>
                                )}
                            </Button>
                        )}
                    </>
                ) : (
                    <></>
                )}{' '}
            </div>
        </div>
    );
};

export default Ticket;
